import React from "react";
import clsx from "classnames";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import { container } from "assets/jss/material-kit-pro-react.jsx";

import { appUrl } from "../../../../config";

const pathUrl = `${appUrl}/media/optafloor`;

const clients = [
  { name: "Laguna", src: `${pathUrl}/logo-laguna.png`, alt: "Laguna Clothing Pvt. Ltd", height: 40 },
  { name: "Ranger", src: `${pathUrl}/logo-ranger.png`, alt: "Ranger Apparel Pvt. Ltd.", height: 40 },
  { name: "Sunlord", src: `${pathUrl}/logo-sunlord.png`, alt: "Sunlord Apparel and Toys", height: 50 },
  { name: "Tkl", src: `${pathUrl}/logo-tkl.png`, alt: "Tropic Knits Pvt. Ltd.", height: 40 },
  { name: "Apollo", src: `${pathUrl}/logo-apollo.png`, alt: "Apollo Fashion.", height: 60 },
];

const useStyle = makeStyles(_ => ({
  container,
  paddingTop: {
    paddingTop: "40px",
  },
  title: {
    fontWeight: "normal",
    textAlign: "center",
  },
  clientContainer: {
    marginTop: "2em",
  },
  client: {
    height: 80,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const Manufacturers = () => {
  const classes = useStyle();
  return (
    <div className={clsx(classes.container, classes.paddingTop)}>
      <Typography className={classes.title} variant="h5">
        Manufacturers working <font color="#4ca0eb">SMARTER</font> with OptaFloor
      </Typography>
      <Grid container justify="center" alignItems="center" className={classes.clientContainer}>
        {clients.map((client, idx) => (
          <Grid item xs={12} md={2} key={idx} className={classes.client}>
            <img src={client.src} alt={client.alt} height={client.height} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default Manufacturers;
